import { DirectUpload } from '@rails/activestorage';

// This mixin requires you have data prop for file and a ref called dropzone on the dropzone element
const directUpload = {

  methods: {
    // callbacks from active storage
    directUploadWillStoreFileWithXHR(xhr) {
      xhr.upload.addEventListener('progress', (event) => this.onProgress(event));
      this.file.status = 'uploading';
      this.$refs.dropzone.$el.dropzone.emit('processing', this.file);
    },

    onProgress(event) {
      const progress = (event.loaded / event.total) * 100;
      this.$refs.dropzone.$el.querySelector('.dz-upload').style.width = `${progress}%`;
    },

    upload() {
      if (this.dzWillUploadCallback) this.dzWillUploadCallback();
      const upload = new DirectUpload(this.file, this.dropzoneOptions.url, this);
      upload.create((error, blob) => {
        if (error) {
          this.fileRemoved();
          this.emitDropzoneError();
          if (this.dzUploadErrorCallback) this.dzUploadErrorCallback(error);
        } else {
          const urlToView = `/rails/active_storage/blobs/${blob.signed_id}/${blob.filename}`;
          this.emitDropzoneSuccess();
          if (this.dzUploadSuccessCallback) this.dzUploadSuccessCallback(urlToView, blob);
        }
      });
    },

    emitDropzoneSuccess() {
      this.file.status = 'success';
      this.$refs.dropzone.$el.dropzone.emit('success', this.file);
      this.$refs.dropzone.$el.dropzone.emit('complete', this.file);
    },

    emitDropzoneError(error) {
      this.file.status = 'error';
      this.$refs.dropzone.$el.dropzone.emit('error', this.file, error);
      this.$refs.dropzone.$el.dropzone.emit('complete', this.file);
    },

  },
};

export default directUpload;
